/* ============================================================
   Free Strap Popup
   Popup UI + Events
============================================================ */

class FreeStrapPopup {
  constructor() {
    this.popup = document.getElementById("FreeStrapPopup");

    if (!this.popup) return;

    this.overlay = this.popup.querySelector(".free-strap-popup__overlay");
    this.closeBtn = this.popup.querySelector(".free-strap-popup__close");
    this.slider = this.popup.querySelector(".free-strap-popup__slider");

    this.currentForm = null;
    this.isSubmitting = false;
    this.flickity = null;

    this.init();
  }

  init() {
    this.bindPopupEvents();
    this.bindProductForms();
  }

  /* -----------------------------
      PRODUCT FORM
  ----------------------------- */

  bindProductForms() {
    // Delegated listener so dynamically-added product forms
    // (quick view, AJAX-loaded sections, etc.) are also caught.
    document.addEventListener(
      "click",
      (event) => {
        const button = event.target.closest(".product-form__submit");

        if (!button) return;

        const form = button.closest("form");

        if (!form) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        this.currentForm = form;
        this.open(form);
      },
      true // capture phase, so this runs before the theme's own submit handler
    );
  }

  /* -----------------------------
      POPUP EVENTS
  ----------------------------- */

  bindPopupEvents() {
    this.closeBtn?.addEventListener("click", () => this.close());
    this.overlay?.addEventListener("click", () => this.close());

    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      if (this.popup.classList.contains("hidden")) return;
      this.close();
    });

    this.popup.addEventListener("click", async (event) => {
      const button = event.target.closest(".free-strap-select");

      if (!button) return;
      if (this.isSubmitting) return;

      const freeVariant = Number(button.dataset.freeVariant);
      const form = this.currentForm;

      if (!form) return;

      const variantInput = form.querySelector('[name="id"]');

      if (!variantInput) return;

      const mainVariant = Number(variantInput.value);

      if (!Number.isFinite(mainVariant) || !Number.isFinite(freeVariant)) {
        console.error("Invalid variant id(s):", { mainVariant, freeVariant });
        return;
      }

      this.selectButtonLoading(button);

      try {
        await this.addItemsToCart([
          { id: mainVariant, quantity: 1 },
          { id: freeVariant, quantity: 1 },
        ]);

        this.close();
      } catch (error) {
        console.error("Free strap add-to-cart failed:", error);
        this.showError(button, "Something went wrong. Please try again.");
      } finally {
        this.isSubmitting = false;
      }
    });
  }

  /* -----------------------------
      CART
  ----------------------------- */

  async addItemsToCart(items) {
    this.isSubmitting = true;

    const cartDrawer = document.querySelector("cart-drawer");

    const sectionsToRender = cartDrawer
      ? cartDrawer.getSectionsToRender().map((section) => section.id)
      : [];

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items,
        sections: sectionsToRender,
        sections_url: window.location.pathname,
      }),
    });

    const result = await response.json();

    if (!response.ok) {
      throw result;
    }

    if (cartDrawer) {
      cartDrawer.renderContents(result);
      cartDrawer.classList.remove("is-empty");
      cartDrawer.open();
    }

    return result;
  }

  /* -----------------------------
      OPEN
  ----------------------------- */

    open(form) {
    this.currentForm = form;

    this.popup.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");

    if (!this.flickity) {
      // NOTE: cell width/responsiveness is controlled via CSS, not JS options.
      // e.g. .free-strap-popup__slide { width: 23%; }  (desktop)
      //      @media (max-width: 990px) { width: 46%; } (tablet)
      //      @media (max-width: 749px) { width: 84%; } (mobile)
      // Keep each slide narrower than 100%/visible-count so neighboring
      // slides peek in at both edges, like the reference screenshot.
      this.flickity = new Flickity(this.slider, {
        cellAlign: "center",
        contain: false,
        wrapAround: true, // infinite loop
        freeScroll: false,
        pageDots: false,
        prevNextButtons: true,
        arrowShape: "M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z",
        adaptiveHeight: false,
      });

      this.flickity.on("change", () => this.updateProgress());

      this.updateProgress();
    } else {
      this.flickity.resize();
      this.updateProgress();
    }
  }
   /* -----------------------------
      PROGRESS BAR
  ----------------------------- */

  updateProgress() {
    if (!this.flickity) return;

    const progressFill = this.popup.querySelector(
      ".free-strap-popup__progress-fill"
    );

    if (!progressFill) return;

    const total = this.flickity.slides.length;
    const percent = total <= 1
      ? 100
      : ((this.flickity.selectedIndex + 1) / total) * 100;

    progressFill.style.width = percent + "%";
  }

  /* -----------------------------
      CLOSE
  ----------------------------- */

  close() {
    this.popup.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");

    this.resetButtons();
    this.isSubmitting = false;
  }

  /* -----------------------------
      BUTTON LOADING / ERROR STATE
  ----------------------------- */

  selectButtonLoading(button) {
    this.isSubmitting = true;

    this.popup.querySelectorAll(".free-strap-select").forEach((btn) => {
      btn.disabled = true;
    });

    button.classList.add("is-loading");
    button.innerHTML = "Adding...";
  }

  resetButtons() {
    this.popup.querySelectorAll(".free-strap-select").forEach((btn) => {
      btn.disabled = false;
      btn.classList.remove("is-loading");
      btn.innerHTML = "Select Strap";
    });
  }

  showError(button, message) {
    this.resetButtons();

    let errorEl = this.popup.querySelector(".free-strap-popup__error");

    if (!errorEl) {
      errorEl = document.createElement("div");
      errorEl.className = "free-strap-popup__error";
      this.popup.appendChild(errorEl);
    }

    errorEl.textContent = message;
  }
}

/* ============================================================
   INIT
============================================================ */

document.addEventListener("DOMContentLoaded", () => {
  if (window.freeStrapPopup) return; // avoid double-init
  window.freeStrapPopup = new FreeStrapPopup();
});